// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1sSnX","label":"Category_label__8h7a6","content":"Category_content__3sxpj","header":"Category_header__1MVm6","location":"Category_location__3jPwj"};